import React from "react";
import { Link } from "react-router-dom";

import PlanComparisonModal from "components/Membership/PlanComparisonModal";
import { PLAN_META, PLAN_ORDER } from "utils/membershipPlans";
import { formatINR } from "utils/format";

function MembershipPlans() {
  const [loggedIn, setLoggedIn] = React.useState(false);
  const [comparisonOpen, setComparisonOpen] = React.useState(false);

  React.useEffect(() => {
    let userInfo = localStorage.getItem("user-info");
    if (userInfo != null) {
      userInfo = JSON.parse(userInfo);
      if (userInfo.session != null) {
        setLoggedIn(true);
      }
    }
  }, []);

  return (
    <section className="hm-block" id="hm-plans">
      <div className="hm-wrap hm-center">
        <span className="hm-eyebrow hm-reveal">Our Membership Plans</span>
        <h2 className="hm-reveal">Choose how you celebrate</h2>
        <p className="hm-lead hm-reveal">
          Contribution is per person. UTSAV is lower for a family of three or more members.
        </p>
        <div className="hm-plans-cta hm-reveal">
          <button
            className="hm-btn hm-btn-outline"
            type="button"
            onClick={() => setComparisonOpen(true)}
          >
            <i className="now-ui-icons files_paper"></i> Compare all plans
          </button>
        </div>
      </div>
      <div className="hm-wrap">
        <div className="hm-plans">
          {PLAN_ORDER.map((name) => {
            const plan = PLAN_META[name];
            return (
              <div
                className={"hm-plan hm-reveal" + (plan.featured ? " hm-feat" : "")}
                key={name}
              >
                <div className="hm-plan-head">
                  <div className="hm-plan-name">{name}</div>
                  <div className="hm-plan-price">
                    ₹{formatINR(plan.price)}
                    <span> / person</span>
                  </div>
                </div>
                <ul>
                  {plan.features.map((f, i) => (
                    <li className={f.on ? "" : "hm-off"} key={i}>
                      {f.text}
                    </li>
                  ))}
                </ul>
                <div className="hm-plan-foot">
                  {loggedIn ? (
                    <Link
                      className="hm-btn hm-btn-outline"
                      to="/membership"
                      style={plan.featured ? { background: "var(--hm-gold)", color: "#3a230a", borderColor: "transparent" } : undefined}
                    >
                      Select plan
                    </Link>
                  ) : (
                    <Link
                      className={"hm-btn " + (plan.featured ? "hm-btn-primary" : "hm-btn-outline")}
                      to="/login"
                    >
                      Create account
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <p className="hm-note">
          * Members share a dedicated queue (shorter waiting time), not preference over
          non-members. Some benefits are subject to surplus-fund and parking availability.
        </p>
      </div>

      <PlanComparisonModal
        isOpen={comparisonOpen}
        onClose={() => setComparisonOpen(false)}
      />
    </section>
  );
}

export default MembershipPlans;
